import { useEffect, useState } from "react";
import "./App.scss";
import { LoginForm } from "./LoginForm";
import { User } from "./types";
import { BrowserRouter } from "react-router-dom";
import { PokerComponent } from "./PokerComponent";
import logo from "./cubeia-logo.png";
import {
  forgetClientSession,
  loadedClientMatches,
  preloadUser,
} from "./poker-client-launch";
function App() {
  const [user, setUser] = useState<User>({ loggedIn: false });
  const login = (user: User) => {
    sessionStorage.setItem("user", JSON.stringify(user));
    // The preloaded client cannot be reused for other launch options; the
    // stored user is launched directly on the fresh page.
    if (!loadedClientMatches(user)) {
      window.location.reload();
      return;
    }
    setUser(user);
  };
  const logout = () => {
    setUser({
      loggedIn: false,
      preload: false,
      webComponent: false,
      operatorId: undefined,
      name: undefined,
    });
    sessionStorage.removeItem("user");
    // The launch options are baked into the poker client's script URL, and that
    // module can only be evaluated once per document. Logging in again with
    // different options therefore has to start from a fresh page.
    window.location.reload();
  };

  useEffect(() => {
    let stored: User | undefined;
    try {
      const userString = sessionStorage.getItem("user");
      if (userString != null) {
        stored = JSON.parse(userString);
      }
    } catch (e) {
      console.log("Unable to read user from session", e);
    }
    if (stored?.loggedIn) {
      setUser(stored);
      return;
    }
    console.log("Preloading poker client web component");
    forgetClientSession();
    setUser(preloadUser());
  }, []);

  return (
    <BrowserRouter>
      {!user.loggedIn && (
        <div className="App">
          <div className={"login-logo mb-2"}>
            <img src={logo} width={"150px"} alt={""} />
          </div>
          <p className={"text-white"}>Demo Poker Platform</p>
          <LoginForm setUser={(user: User) => login(user)} />
        </div>
      )}
      <PokerComponent user={user} logOut={logout} />
    </BrowserRouter>
  );
}

export default App;
